<template>
  <div class="advantages">
    <ul>
      <li v-for="advantage in advantages">{{advantage}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    advantages: {
      type: Array,
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
.advantages {
  ul {
    display: flex;
    justify-content: center;

    li:last-child {
      margin-right: 0;
    }

    li {
      font-size: 15px;
      font-weight: 400;
      text-align: center;
      color: rgb(27, 39, 51);
      margin-right: 46px;
      position: relative;

      &:before {
        display: inline-block;
        content: "";
        width: 17px;
        height: 17px;
        margin-right: 4px;
        margin-bottom: -1px;
        background-image: url('../images/landing/check.svg');
      }

      @media (max-width: 767px) {
        margin: 8px 16px;

        &:last-child {
          margin-right: 16px!important;
        }
      }
    }



    @media (max-width: 767px) {
      flex-flow: wrap;
    }
  }

  @media (max-width: 767px) {
    margin-top: 24px;
  }
}
</style>
